import { colors } from "src/styles/theme";
import { styled } from "styled-components";
import { useEffect, useState } from "react";
import { createTeeshotAxiosInstance } from "src/http";
import ContentBox from "../ContentBox";

export default function WaitYearBookingProposal() {
  const [clubs, setClubs] = useState<{ id: number; name: string }[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await createTeeshotAxiosInstance().get("/yearBooking/booking");
        const data = res?.data?.data;
        const clubRels = data?.clubRels || [];
        console.log(clubRels);
        setClubs(
          clubRels.map((cr: any) => ({ id: cr?.id ?? Math.random(), name: cr?.name || "" }))
        );
      } catch (e) {
        console.log("Failed to fetch booking application:", e);
      }
    })();
  }, []);

  return (
    <Container className="d-flex fd-c gap-2">
      <div className="d-flex fd-c gap-2">
        {clubs.map((c) => (
          <ContentBox
            key={`club-${c.id}`}
            colorTheme="gray"
            content={
              <div className="club-card d-flex fd-c gap-1">
                <div className="d-flex jc-sb ai-c">
                  <h4 className="club-name">{c.name}</h4>
                  <span className="status-badge">검토중</span>
                </div>
                <div className="desc">신청하신 조건을 골프장에서 검토중입니다.</div>
              </div>
            }
          />
        ))}
      </div>
    </Container>
  );
}

const Container = styled.div`
  header {
    font-size: 16px;
    font-weight: bold;
    .left {
      color: ${colors.green.second};
    }
    .right {
      color: ${colors.gray.second};
    }
  }

  .ani-box {
    > div {
      max-width: 250px;
    }
    min-width: 1px;
  }

  .club-card {
    .club-name {
      font-size: 18px;
      font-weight: bold;
      color: ${colors.gray.first};
      margin: 0;
    }
    .status-badge {
      background: ${colors.gray.second};
      color: #fff;
      border-radius: 8px;
      padding: 4px 8px;
      font-size: 12px;
    }
    .desc {
      color: ${colors.gray.second};
    }
  }
`;
